import Reflux from 'reflux';
import TeamData from 'shared/data/Team';

// var userId = null;

let async = { asyncResult: true },
  TeamFormActions = Reflux.createActions({
    updateField: {},
    setPhotoPreviewUri: {},
    setPhotoPreviewError: {},
    submit: async,
  });

export default TeamFormActions;

TeamFormActions.submit.listenAndPromise(TeamData.create);
